import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTE_SECURITY_CONTACTS, ROUTE_SECURITY_CONTACTS_ADD, ROUTE_WELCOME } from "../../routes/Routes";
import ScrollView from 'devextreme-react/scroll-view';
import 'devextreme/dist/css/dx.light.css';
import { BasicSecurityForm } from '../../components/BasicSecurity/BasicSecurityForm';
import PutPostPatchFetch from "../../hooks/PutPostPatchFetch";
import './AddContacts.scss';
import usePageTitle from "../../hooks/usePageTitle";
import { DateBox } from "devextreme-react";
import { Toast } from "devextreme-react/toast";
import { ValidationMessageItem } from "./ValidationMessageItem/ValidationMessageItem";

const AddSecurityContacts = () => {
    const { title } = ROUTE_SECURITY_CONTACTS_ADD;
    usePageTitle(title);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [_billingDate, set_BillingDate] = useState();
    const [data, setData] = useState(null);    
    const [validationMessage, setValidationMessage] = useState([]);    
    const [errorMessage, setErrorMessage] = useState('');
    const [notification, setNotification] = useState({
        message: '',
        type: undefined,
        visible: false
    });

    const navigate = useNavigate();
    const navigateToRoute = () => navigate(ROUTE_WELCOME.withSlash);

    const newSecurityContact = {
        Id: 0,
        BillDate: null,
        UploadFile: null,
    }

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        setData(newSecurityContact);
        console.log(data)
    };

    const handleFileUpload = (event) => {
        const files = Array.from(event.target.files);
        const { size } = event.target.files[0];
        const maxFileSize = 25000000; // 25 MB

        if (size && size >= maxFileSize) {
            setNotification({
                isVisible: true,
                message: 'The file you have selected is too large in size. Please choose a .csv file with a size that is under 25 MB.',
                type: 'error'
            });
        };
        
        if (size && size < maxFileSize) {
            setNotification({
                isVisible: true,
                message: 'File selection successful.',
                type: 'success'
            });
            setSelectedFiles(prevFiles => [...prevFiles, ...files]);
        };

        fileInputRef.current.value = "";
    };

    const RemoveSelectedFiles = async (event) => {
        event.preventDefault();
        selectedFiles.length = 0;
        setSelectedFiles(prevFiles => [...prevFiles, ...selectedFiles]);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData();

        for (let i = 0; i < selectedFiles.length; i++) { 
            formData.append("Files", selectedFiles[i])
        };

        try {
            const { Errors, Message, Success } = 
                await PutPostPatchFetch(`/v1/BasicSecurity/Contacts?billingDate=${_billingDate}`, 
                'POST', formData, 'multipart/form-data');

            if (Success) {
                setNotification({
                    isVisible: true,
                    message: 'File submitted successfully.',
                    type: 'success'
                });
            } 
            
            if (Errors) {
                setErrorMessage(true);
                setNotification({
                    isVisible: true,
                    message: Errors[0].ErrorMessages,
                    type: 'error'
                });
                setValidationMessage(Errors[0].ErrorMessages);
            }
        } catch (error) {
            console.error('Error: ', error);
        }

    };
    
    const convertToMegabits = (number) => {
        if (number > 999) {
            number / 1000;
            const fixedNumber = Math.round(number / 100) / 10
            return <> {fixedNumber} MB </>;
        };
        
        return <> {number} KB </>;
    };

    const handleToastHiding = () => {
        setNotification(() => ({ 
            message: '',
            type: undefined, 
            isVisible: false
        }))
    };

    return (
        <div>
        <div>
            <h1> {title} </h1>
                        <ScrollView className='view-wrapper-scroll'>
                <div className='view-wrapper view-wrapper-contact-details'>
                    <div className='panels'>
                        <BasicSecurityForm
                        data={data}
                        fileExtensions= {['.csv']}
                        postPath='/v1/BasicSecurity/UploadSecurityContacts?billingDate='
                        backPath={ROUTE_SECURITY_CONTACTS.withSlash}
                        isLoading={false}
                        isEditing={true}
                        />
                    </div>
                </div>
            </ScrollView>
{/*             <div className="block block__div--wrapper">
                <DateBox
                    dateSerializationFormat="MM/dd/yyyy"
                    useMaskBehavior={true}
                    displayFormat="monthAndYear"
                    inputAttr={{
                        "aria-label": "Billing Date",
                        "aria-required": "true"
                    }}
                    label="Billing Date"
                    onValueChanged={(e) => set_BillingDate(e.value)}
                    showDropDownButton={false}
                    type="date"
                    value={_billingDate ?? null}
                    variant={"outlined"}
                />
            </div>            
            <div className="list-container">
                <List
                    height="100%"
                    title="Error Messages"      
                />
            </div>
            <div className="block block__div--wrapper">
                <BaseButton
                    label={"Select file"}
                    onClick={() => document.getElementById('file-upload-input').click()}
                    variant={"outlined"}
                />
                <input
                    type="file"
                    accept=".csv"
                    multiple
                    onChange={handleFileUpload}
                    style={{ display: 'none' }}
                    id="file-upload-input"
                />
                <BaseButton
                    aria-disabled={selectedFiles.length === 0}
                    disabled={selectedFiles.length === 0}
                    onClick={handleSubmit}
                    variant={"outlined"}
                    label={"Submit"}

                />
            </div>

            <div className="block">
                <div className={
                    selectedFiles.length === 0 ? 
                    "block__unscrollable-container" 
                    : 
                    "block__scrollable-container"
                    }>
                    {
                        selectedFiles.length === 0 && 
                        <div className="inline__empty-list">                            
                            <span>
                                No Files Selected
                            </span>
                        </div>
                        
                    }
                    {
                        selectedFiles.length > 0 &&
                        <ul className="block__unordered-list">
                            {
                                selectedFiles.map(({
                                    index,
                                    name, 
                                    size
                                }) => {
                                    const formattedSize = convertToMegabits(size);
                                    return (
                                        //TODO: Using name instead of index gets rid of error, but need to find a better indexing method
                                        <li key={name} className="inline__list-item">
                                            <span className="inline__span--file-name">
                                                {name} 
                                            </span>
                                            <span className="inline__span--file-size">
                                                {formattedSize}
                                            </span>
                                        </li>
                                    );
                                })
                            }
                        </ul>
                    }
                </div>
            </div>
               
            <div className="block block__div--wrapper">
                <BaseButton
                    label={"cancel"}
                    variant={"outlined"}
                    onClick={RemoveSelectedFiles}
                />
            </div>

            {
                errorMessage &&
                <div className="list-container">
                    <>
                        <h2 className="h2--validation-errors"> Validation Errors </h2>
                        <List
                            dataSource={validationMessage}
                            height="100%"
                            itemRender={ValidationMessageItem}
                        />
                    </>
                </div>
            }            

            <Toast 
                animation={{
                    show: {
                        type: 'fade',
                        duration: 300,
                        from: 0,
                        to: 1
                    },
                    hide: {
                        type: 'fade',
                        duration: 300,
                        from: 1,
                        to: 0
                    }
                }}
                closeOnClick={true}
                displayTime={86400000}
                focusStateEnabled={true}
                message={notification.message}
                onHiding={handleToastHiding}
                type={notification.type}
                visible={notification.isVisible}
            /> */}
        </div>
    </div>
    );
};

export default AddSecurityContacts
